import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import {
	Grid,
	ListItem,
	ListItemText,
	Paper,
	Switch,
	Typography,
	makeStyles,
} from "@material-ui/core";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import React from "react";
import { useTranslate } from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { reorderOnDragEnd } from "utils/dragAndDrop";

const KINDS = ["truck", "trailer", "trip"];
const DIRECTIONS = ["incoming", "outgoing"];

const useStyles = makeStyles((theme) => ({
	board: { padding: theme.spacing(2) },
	row: { paddingLeft: 0 },
	rank: { minWidth: 28, fontWeight: 500 },
	disabled: { opacity: 0.5 },
}));

const GroupingPriorityInput = ({ direction }) => {
	const classes = useStyles();
	const translate = useTranslate();
	const form = useForm();
	const { values } = useFormState({ subscription: { values: true } });
	const source = `${direction}_grouping_priorities`;
	const enabledPriorityOrder = values[source] || [];
	const disabledPriorities = KINDS.filter((kind) => !enabledPriorityOrder.includes(kind));

	const handleDragEnd = (result) => {
		const reordered = reorderOnDragEnd(result, enabledPriorityOrder);
		if (reordered) form.change(source, reordered);
	};

	const switchPriority = (name) => {
		const newValue = new Set(enabledPriorityOrder);
		newValue.has(name) ? newValue.delete(name) : newValue.add(name);
		form.change(source, [...newValue]);
	};

	const label = (name) => translate(`resources.terminal.grouping_priorities.${name}`);

	return (
		<Paper variant="outlined" className={classes.board}>
			<Typography variant="subtitle1">{label(direction)}</Typography>

			<DragDropContext onDragEnd={handleDragEnd}>
				<Droppable droppableId={direction}>
					{(dropProvided) => (
						<div ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
							{enabledPriorityOrder.map((name, index) => (
								<Draggable key={name} draggableId={name} index={index}>
									{(dragProvided) => (
										<ListItem
											ref={dragProvided.innerRef}
											{...dragProvided.draggableProps}
											{...dragProvided.dragHandleProps}
											className={classes.row}
											style={dragProvided.draggableProps.style}
										>
											<DragIndicatorIcon />
											<span className={classes.rank}>{index + 1}</span>
											<ListItemText primary={label(name)} />
											<Switch checked onChange={() => switchPriority(name)} />
										</ListItem>
									)}
								</Draggable>
							))}
							{dropProvided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>

			{disabledPriorities.map((name) => (
				<ListItem key={name} className={`${classes.row} ${classes.disabled}`}>
					<ListItemText primary={label(name)} />
					<Switch checked={false} onChange={() => switchPriority(name)} />
				</ListItem>
			))}
		</Paper>
	);
};

export const GroupingPrioritiesInput = () => (
	<Grid container spacing={2}>
		{DIRECTIONS.map((direction) => (
			<Grid item xs={12} sm={6} key={direction}>
				<GroupingPriorityInput direction={direction} />
			</Grid>
		))}
	</Grid>
);
